// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.leader-details .el-textarea.is-disabled .el-textarea__inner {\r\n  font-family:\r\n    'Noto Sans TC',\r\n    sans-serif,\r\n    Arial,\r\n    Microsoft JhengHei !important;\r\n  font-size: 1.1rem;\r\n  line-height: 1.75;\r\n  color: #1a1a1a;\r\n  font-weight: 300;\r\n  /* font-size: 17px; */\r\n  background-color: snow;\r\n  border-color: #dfe4ed;\r\n  color: steelblue !important;\r\n  cursor: not-allowed;\n}\r\n", ""]);
// Exports
module.exports = exports;
